const ACTIVE = 'ACTIVE'
const INACTIVE = 'INACTIVE'
const PENDING = 'PENDING'

const STATUS = {
  ACTIVE,
  INACTIVE,
  PENDING,
}

const organizationUsers = {
  STATUS,
}

export default organizationUsers
